module.exports = __webpack_public_path__ + "img/er.1e16912d.jpg";